import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "18",
      height: "18",
      x: "3",
      y: "3",
      fill: "rgb(var(--v-theme-white, 255, 255, 255))",
      rx: "3"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M18.586 3A2.415 2.415 0 0 1 21 5.415v13.17A2.414 2.414 0 0 1 18.586 21H5.414A2.414 2.414 0 0 1 3 18.586V5.414A2.414 2.414 0 0 1 5.414 3zM8.488 11.122A.88.88 0 0 0 7.61 12a.88.88 0 0 0 .878.878h7.024A.88.88 0 0 0 16.39 12a.88.88 0 0 0-.878-.878z"
    }, null, -1)
  ]))]))
}
export default { render: render }